import { useState, useEffect } from "react";

import withUser from "../../../wrappers/withUser";
import { userData } from "../../../types";
import { TextField, Stack, Typography, FormControlLabel, Checkbox, Button } from "@mui/material";
import { useLazyGetExamComponentBaseQuery, usePostQuestionMutation, usePostAnswerChoiceMutation} from "../../../api";
import { useSystemMessage } from "../../../providers/SystemMessageContext";


const ExamStudio = ({userData}:{userData:userData}) => {
    //console.log(userData);
    const { showMessage } = useSystemMessage();

    ///////////////////////////////
    // EXAM COMPONENT BASE
    ///////////////////////////////
    const [examComponentBase, setExamComponentBase] = useState<string | null>(null);
    const {run: triggerGetExamComponentBaseData, data: examComponentBaseData, loading:examComponentBaseIsLoading} = useLazyGetExamComponentBaseQuery(examComponentBase);
    const handleGetExamComponentBaseData = async () => {
        await triggerGetExamComponentBaseData()
            .catch((error) => {
                console.log(error)
            });
    };
    useEffect(() => {
        if (!examComponentBase) return;
        handleGetExamComponentBaseData();
    }, [examComponentBase]);

    ///////////////////////////////
    // QUESTION
    ///////////////////////////////
    const [questionNumber, setQuestionNumber] = useState<number | null>(null);
    const [questionText, setQuestionText] = useState<string | null>(null);
    const [aboveText, setAboveText] = useState<string>("");
    const { submit:triggerQuestionMutation, data:questionMutation, error:questionMutationError, loading: isMutatingQuestion } = usePostQuestionMutation();
    const handlePostQuestion = async () => {
        await triggerQuestionMutation({
            "create": {
                "exam_component_base_id":examComponentBase,
                "question_number": questionNumber,
                "above_text": aboveText,
                "question_text": questionText,
            }
        }).catch((error) => {
            console.log(error);
        })
    };
    useEffect(() => {
        if (questionMutation) {
            showMessage(questionMutation.message, questionMutation.success ? "success" : "error");
        } else if (questionMutationError) {
            showMessage(questionMutationError.response.data.message, questionMutationError.response.data.success ? "success" : "error");
        }
    }, [questionMutation, questionMutationError]);

    ///////////////////////////////
    // ANSWER CHOICE
    ///////////////////////////////
    const [questionID, setQuestionID] = useState<number | null>(null);
    const [optionNumber, setOptionNumber] = useState<number | null>(null);
    const [optionText, setOptionText] = useState<string | null>(null);
    const [isCorrect, setIsCorrect] = useState<boolean>(false);
    const { submit:triggerAnswerChoiceMutation, data:answerChoiceMutation, error:answerChoiceMutationError, loading: isMutatingAnswerChoice } = usePostAnswerChoiceMutation();
    const handlePostAnswerChoice = async () => {
        await triggerAnswerChoiceMutation({
            "create": {
                "question_id":questionID,
                "option_number": optionNumber,
                "option_text": optionText,
                "is_correct": isCorrect,
            }
        }).catch((error) => {
            console.log(error);
        })
    };
    useEffect(() => {
        if (answerChoiceMutation) {
            showMessage(answerChoiceMutation.message, answerChoiceMutation.success ? "success" : "error");
        } else if (answerChoiceMutationError) {
            showMessage(answerChoiceMutationError.response.data.message, answerChoiceMutationError.response.data.success ? "success" : "error");
        }
    }, [answerChoiceMutation, answerChoiceMutationError]);
    

    return (
        <Stack direction="column" gap={1} sx={{width:'100%'}}>
            <TextField 
                label='Exam Component ID'
                type="number"
                value={examComponentBase}
                onChange={(e) => {
                    setExamComponentBase(e.target.value.toString())
                }}
            />
            {(examComponentBaseData && examComponentBaseData.data?.length > 0) && (
                <>
                    <Typography>{examComponentBaseData.data[0].exam_base}, {examComponentBaseData.data[0].exam_component_title}</Typography>
                    
                    <Typography>Question</Typography>
                    <TextField 
                        label='number'
                        type="number"
                        value={questionNumber}
                        onChange={(e) => {
                            setQuestionNumber(parseInt(e.target.value))
                        }}
                    />
                    <TextField 
                        label='above text'
                        value={aboveText}
                        onChange={(e) => {
                            setAboveText(e.target.value)
                        }}
                    />
                    <TextField 
                        label='text'
                        value={questionText}
                        onChange={(e) => {
                            setQuestionText(e.target.value)
                        }}
                    />
                    <Button variant="contained" onClick={handlePostQuestion}>Submit Question</Button>
                    {(questionMutation && questionMutation.data.length > 0) && (
                        <Typography>Last Mutated Question ID: {questionMutation.data[0].id}</Typography>
                    )}

                    <Typography>Answer Choice</Typography>
                    <TextField 
                        label='question ID'
                        type="number"
                        value={questionID}
                        onChange={(e) => {
                            setQuestionID(parseInt(e.target.value))
                        }}
                    />
                    <TextField 
                        label='option'
                        type="number"
                        value={optionNumber}
                        onChange={(e) => {
                            setOptionNumber(parseInt(e.target.value))
                        }}
                    />
                    <TextField 
                        label='text'
                        value={optionText}
                        onChange={(e) => {
                            setOptionText(e.target.value)
                        }}
                    />
                    <FormControlLabel 
                        control={
                            <Checkbox
                                defaultChecked={false}
                                checked={isCorrect}
                                onChange={(e) => {
                                    setIsCorrect(e.target.checked)
                                }}
                            />
                        }
                        label="Is Correct"
                    />
                    <Button variant="contained" onClick={handlePostAnswerChoice}>Submit Answer Choice</Button>
                </>
            )}
        </Stack>
    )
};

export default withUser(ExamStudio);